import React from 'react'

const perfilRoutes = [
    {
        path: '/perfil/novo',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },
]

export default perfilRoutes
